import { Controller } from "@hotwired/stimulus";
import { dialogCancelButtonClassName, dialogConfirmationButtonClassName } from "../../../../scripts/dialogConstants";
import { postRequestAndWaitForJobCompletion } from "../../../../scripts/jobCompletion";
import { translate } from "../../../../scripts/translate";
import * as TranslationsKeys from "../../../../scripts/locale/translationsKeys";
import { DomEvents } from "../../../../scripts/_generated/DomEvents";

export default class AiGeneratedContentController extends Controller {
    static values = {
        getJobUrl: String,
        generateUrl: String,
        poiUniqueId: String,
    };

    readonly getJobUrlValue!: string;
    readonly generateUrlValue!: string;
    readonly poiUniqueIdValue!: string;

    connect() {
    }

    generate(event: Event) {
        const generateButton = event.currentTarget as HTMLElement;

        const action = () => {
            const data = new FormData();
            data.append("commaSeparatedPoiUniqueIds", this.poiUniqueIdValue);
            postRequestAndWaitForJobCompletion(this.generateUrlValue,
                data,
                this.getJobUrlValue,
                $(generateButton),
                () => {
                    this.dispatch(DomEvents.poiDetailAiGeneratedContentModified);
                });
        };

        bootbox.confirm({
            message: 'Generating Narrative and Learn more via AI will replace the current Narrative and Learn more. Please confirm.',
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                action();
            }
        });
    }
}
